
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 497 522","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M437.051 456.813c0 15.108-1.741 16.854-17.433 16.854h-171.45c-57.538 0-114.496 0-171.45.58-14.534 0-16.859-2.905-16.859-16.855V223.654c0-14.529 2.909-17.437 16.859-17.437h343.479c13.95 0 16.854 2.325 16.854 16.854v233.742zm-56.375-429.5v131.933c0 14.53-2.325 16.854-16.854 16.854H134.255c-13.95 0-16.854-2.908-16.854-17.437V24.408v2.905h263.275zm106.359 18.6c-13.367-12.788-26.155-25.571-39.521-37.776-3.488-2.908-7.554-6.975-11.625-6.975C427.772.637 44.376 0 40.68 0 11.622 0 0 11.62 0 40.683v439.955C0 509.7 12.2 521.32 41.264 521.32H458.56c26.15 0 37.77-12.204 38.354-38.358V69.742c.583-9.88-2.904-17.438-9.88-23.83z"}}),_c('path',{attrs:{"d":"M280.276 153.633h44.463a5.656 5.656 0 005.658-5.658v-99.6a5.658 5.658 0 00-5.658-5.658h-44.463a5.658 5.658 0 00-5.658 5.658v99.6a5.656 5.656 0 005.658 5.658zM108.097 377.059h280.717v30.075H108.097zM108.097 269.3h280.717v30.075H108.097zM108.097 323.184h280.717v30.07H108.097z"}})])])
          )
        }
      }
    